










































import { SettingApi } from "../../api/SettingApi";
import InputField from "../../core/Forms/InputField.vue";

export default {
    name: "LogoUploader",
    components: { InputField },
    data() {
        return {
            SettingApi: new SettingApi(),
        };
    },
    methods: {
        handleFiles: function (event) {
            let self = this;
            let file = _.first(event.target.files);
            if (file) {
                self.SettingApi.uploadLogo(file)
                    .then(function (res) {
                        let logoImg = document.getElementById(
                            "current-logo"
                        ) as HTMLImageElement;
                        logoImg.src = logoImg.src + "?" + _.uniqueId();
                    })
                    .catch(function (error) {});
            }
        },
    },
};
